import { includesId } from "./helpers";
export function passThreshold(down, move, threshold = 5) {
    return (Math.abs(move.x - down.x) > threshold ||
        Math.abs(move.y - down.y) > threshold);
}
export function isInRange(val, range) {
    return val >= range[0] && val <= range[1];
}
export function isInRect(coords, rect) {
    const { x, y } = coords;
    const byX = isInRange(x, [rect.x, rect.right]);
    const byY = isInRange(y, [rect.y, rect.bottom]);
    return byX && byY;
}
export function getDragItemCoords(current, pointerDown, dragItemOrigin) {
    const diff = {
        x: pointerDown.x - dragItemOrigin.x,
        y: pointerDown.y - dragItemOrigin.y,
    };
    return { x: current.x - diff.x, y: current.y - diff.y };
}
export function getCoords(kanbanEl, dragItemId, updateMode = false) {
    const columns = Array.from(kanbanEl.querySelectorAll("[data-drop-area]"));
    const dragItems = Array.isArray(dragItemId) ? dragItemId : [dragItemId];
    const draggedItem = kanbanEl.querySelector(`[data-drag-item='${dragItems[dragItems.length - 1]}']`);
    const dragItemHeight = draggedItem?.offsetHeight || 300;
    const dragItemsCoords = {};
    const dropAreasCoords = [];
    const dropAreaItemsCoords = columns.reduce((totalMap, col) => {
        const colRect = JSON.parse(JSON.stringify(col.getBoundingClientRect()));
        const columnId = col.getAttribute("data-drop-area");
        const cards = Array.from(col.querySelectorAll("[data-drag-item]"));
        const stayed = [];
        const coords = cards.reduce((total, cardElem) => {
            const rect = JSON.parse(JSON.stringify(cardElem.getBoundingClientRect()));
            const id = cardElem.getAttribute("data-drag-item");
            const prevItem = total[total.length - 1];
            const y = prevItem?.bottom ?? rect.y;
            const itemCoords = { ...rect, y, id };
            dragItemsCoords[id] = itemCoords;
            total.push(itemCoords);
            if (!includesId(dragItems, id)) {
                stayed.push(id);
            }
            return total;
        }, []);
        const stayedItems = stayed.map((id, i) => {
            return { ...coords[i], id };
        });
        if (!updateMode) {
            const colParentHeight = col.offsetParent;
            const gap = 30;
            const colBottom = col.offsetTop + col.offsetHeight + gap;
            if (colBottom >= colParentHeight.scrollHeight) {
                colRect.bottom += dragItemHeight + gap;
                colRect.height += dragItemHeight + gap;
            }
        }
        dropAreasCoords.push({ ...colRect, id: columnId });
        totalMap[columnId] = stayedItems;
        return totalMap;
    }, {});
    return { dragItemsCoords, dropAreasCoords, dropAreaItemsCoords };
}
export function getEventData(e) {
    const ev = {};
    ev.target = e.target;
    if ("touches" in e) {
        const firstTouch = e.touches[0];
        ev.touches = e.touches;
        ev.clientX = firstTouch.clientX;
        ev.clientY = firstTouch.clientY;
    }
    else {
        ev.clientX = e.clientX;
        ev.clientY = e.clientY;
    }
    return ev;
}
//# sourceMappingURL=dnd.js.map